import {Typography,Button,Grid, Container,CardActions,Card,CardMedia,CardContent} from '@material-ui/core';
import useStyles from './styles';
import Modal from '../modals/Modal';
import React, { useState } from 'react';
import MoreHorizIcon  from '@material-ui/icons/MoreHoriz';
import python from '../../certificates/python.jpg';
import jpmorgan from '../../certificates/jp.png';
import machinelearning from '../../certificates/ml.jpg';
import neuralnetwork from '../../certificates/neuralnet.png';
import prepbytes from '../../certificates/prepbytes.png';
import tensorflow from '../../certificates/tensorflow.png'
const Certificates = (props)=>{
    const classes = useStyles();
    const [show,setShow]=useState({
        value:false,
        image:''
    });
    const addShowHandler = (event)=>{
        console.log(event.target.id);
        const obj = {
            value:true,
            image:event.target.id
        }
        console.log(obj)
        setShow(obj);
    }
    const cancelHandler = ()=>{
        const obj = {
            value:false,
            image:''
        };
        console.log(obj)
        setShow(obj);
    }
    const cards = [
        {
            id:'1c',
            name:'Python',
            img:python,
            link:'https://www.udemy.com/certificate/UC-9db883ef-2f44-4c91-bc67-902270d60ec3/'
        },
        {
            id:'2c',
            name:'Neural Networks',
            img:neuralnetwork,
            link:'https://www.coursera.org/account/accomplishments/certificate/5Q9FFXQNBF4R'
        },
        {
            id:'3c',
            name:'Machine Learning',
            img:machinelearning,
            link:'https://www.udemy.com/certificate/UC-41be7d7c-96e0-4e97-8d2f-82589ae8a09d/'
        },
        {
            id:'4c',
            name:'Campus Business Manager',
            img:prepbytes,
            link:'#'
        },
        {
            id:'5c',
            name:'TensorFlow',
            img:tensorflow,
            link:'https://www.coursera.org/account/accomplishments/certificate/KGHMDMHRRFDM'
        },
        {
            id:'6c',
            name:'Jp Morgan',
            img:jpmorgan,
            link:'https://insidesherpa.s3.amazonaws.com/completion-certificates/JP%20Morgan/R5iK7HMxJGBgaSbvk_JPMorgan%20Chase_P3pSghmFYcaMQBg42_completion_certificate.pdf'
        },
    ]
    return(
        <React.Fragment>

        {show.value && <Modal image={show.image} onCancel={cancelHandler}/> }
        <main className={classes.main}>
        <Container className={classes.container} maxWidth='md'>
                    <Typography variant='h2' align='center' color='textPrimary' gutterBottom>
                    Certificates
                    </Typography>
                    <Typography variant = 'h5' align='center' gutterBottom color = 'textSecondary'>
                        These are some of the course certificates that i have recieved.
                    </Typography>
        </Container>
        <Container  className={classes.cardGrid} maxWidth='xl'>
			<Grid container spacing={4}>
				{cards.map(card=>(
					<Grid key={card.id} item xs={12} sm={6} md={4} lg={3}>
					<Card className={classes.card}>
						<CardMedia className={classes.cardMedia} image={card.img} />
                        <div className={classes.overlay2}>
                            <Button style={{color:'black'}}  onClick={addShowHandler} size='small' >
                                <MoreHorizIcon id={card.img}  fontSize='default'/>
                            </Button>
                        </div>
						<CardContent className={classes.cardContent}>
							<Typography gutterBottom variant='h5'>
								{card.name}
							</Typography>
						</CardContent>
						<CardActions>
							<a href={card.link}><Button size='small' color='primary'>View</Button></a>
						</CardActions>
					</Card>
				</Grid>
				))}
			</Grid>
		</Container>
        </main>
        </React.Fragment>
    )
}
export default Certificates;